import { useEffect, useState } from 'react'

/** Subscribes to a media query. Safe under jsdom, where `matchMedia` is a stub. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(query).matches,
  )
  useEffect(() => {
    const media = window.matchMedia(query)
    const onChange = (): void => {
      setMatches(media.matches)
    }
    media.addEventListener('change', onChange)
    onChange()
    return () => {
      media.removeEventListener('change', onChange)
    }
  }, [query])
  return matches
}

/** The FRONTEND_PLAN §5 breakpoint where a detail view becomes a drawer instead of its own page. */
export function useIsWide(): boolean {
  return useMediaQuery('(min-width: 1024px)')
}
